import {
  BackOfficeDataProvider,
  defaultUrlRenderer
} from 'shared/services/backoffice-data-provider';

import { LeaderboardDtoConverter } from './LeaderboardDtoConverter';

export class LeaderboardDataProvider extends BackOfficeDataProvider {
  protected dtoConverter = new LeaderboardDtoConverter();
  protected urlRenderer = defaultUrlRenderer;
}
